import React, { Component } from 'react';
import { Form,Button } from 'react-bootstrap';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import actions from './../../store/Actions/index.js';


class UpdateChapter extends Component{
    state={
        chapterName:""
    }

    onSubmit = (evt) => {
        evt.preventDefault();
        this.props.updateChapterName({chapterId:this.props.chapterId,chapterName:this.state.chapterName});
        window.location.reload(true);
    }
    render(){
        return(
            <div>
                <Form onSubmit={this.onSubmit}>
                    <Form.Group>
                        <Form.Label>
                            Update Chapter
                        </Form.Label>    
                        <Form.Control type="input" value={this.state.chapterName} onChange={(evt) => {
                            this.setState({chapterName:evt.target.value});
                        }}>
                        </Form.Control>
                    </Form.Group>
                    <Button varient="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    state:state
});

const mapDispatchToProps = (dispatch) => ({
    updateChapterName : (v)=> dispatch(actions.updateChapterName(v))
});

module.exports = withRouter(connect(mapStateToProps,mapDispatchToProps)(UpdateChapter))


// WEBPACK FOOTER //
// ./src/components/UpdateChapter/updateChapter.jsx